const appPages = [
  '/home',
  '/browse',
  '/messages',
  '/shoutout',
  '/billing',
  '/store',
  '/products',
  '/dashboard',
  '/profile',
  '/settings',
  '/subscribe',
  '/post',
  '/posts',
  '/payment-method-selection',
  '/subscription-plans'
];

function isNonProfileApp(location) {
  if (appPages.find((x) => location?.includes(x || ''))) return true;

  return false;
}

export default isNonProfileApp;
